import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';
import CustomButton from '../reusable/CustomButton';
import { Menu, MenuItem } from '@mui/material';
import EditIcon from '../assets/nav-edit.svg';
import { getRoleHomePath, hasSelectedEoa } from '../district-selection/districtSelectionUtils';

import './DistrictBar.css';

const DistrictBar = () => {
  const { userDetails, allEoas, switchEoa } = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const buttonRef = useRef<HTMLDivElement>(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (!hasSelectedEoa(userDetails.data) || !allEoas.data || allEoas.data.length === 0) {
    return null;
  }

  const currentDistrict = userDetails.data!.district.name;
  const hasMultipleEoas = allEoas.data.length > 1;

  const handleOpenMenu = () => {
    setIsMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleSelectDistrict = (eoaId: string) => {
    const selectedEoa = allEoas.data!.find((eoa) => eoa.id === eoaId);
    if (selectedEoa) {
      switchEoa(eoaId);
      navigate(getRoleHomePath(selectedEoa.user_roles[0]));
    }
    handleCloseMenu();
  };

  return (
    <>
      <div className="district-bar" data-testid="district-bar">
        <p className="no-margin selected-district" data-testid="current-district">
          {currentDistrict}
        </p>
        {hasMultipleEoas && (
          <>
            <div ref={buttonRef}>
              <CustomButton
                variant="clear"
                buttonText="Change District"
                buttonAction={handleOpenMenu}
                sx={{ fontSize: 'var(--font-size-14)', color: 'var(--text-white)' }}
                icon={<img alt="change district icon" src={EditIcon} />}
                iconPosition="start"
              />
            </div>
            <Menu
              anchorEl={buttonRef.current}
              open={isMenuOpen}
              onClose={handleCloseMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              {allEoas.data.map((eoa) => (
                <MenuItem
                  key={eoa.id}
                  onClick={() => handleSelectDistrict(eoa.id)}
                  selected={eoa.id === userDetails.data?.eoaId}
                >
                  {eoa.district.name}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
      </div>
    </>
  );
};

export default DistrictBar;
